import type { RankedBarOpts, TransformerRegistry } from './Types.ts'
import { kronaOptsKey, kronaTraitOptsKey } from './OptsKey.ts'
import { selectKronaFilteredBuckets } from './Impl/KronaFilteredBuckets.ts'
import { selectTaxaAggregation } from './Impl/TaxaAggregation.ts'
import { selectTaxaAggregationSingle } from './Impl/TaxaAggregationSingle.ts'
import { selectTaxaLeafAggregationSingle } from './Impl/TaxaLeafAggregationSingle.ts'
import { selectTaxaRankedBarSingle } from './Impl/TaxaRankedBarSingle.ts'
import { selectTaxaStackedBarSeries } from './Impl/TaxaStackedBarSeries.ts'
import { selectTaxaNavigatorIndex } from './Impl/TaxaNavigatorIndex.ts'
import { selectTaxaAutoDescendTarget } from './Impl/TaxaAutoDescendTarget.ts'
import { selectTraitStackedBarSeries } from './Impl/TraitStackedBarSeries.ts'
import { selectTraitAggregationSingle } from './Impl/TraitAggregationSingle.ts'

const rankedBarOptsKey = (o: RankedBarOpts) => `${kronaOptsKey(o)}|rl=${o.rankLevel ?? ''}`

export const transformerRegistry: TransformerRegistry = {
  kronaFilteredBuckets: {
    kind: 'selector',
    optsKey: kronaOptsKey,
    select: (state, sourceId, bucketKey, opts) => selectKronaFilteredBuckets(state, sourceId, bucketKey, opts, kronaOptsKey(opts))
  },

  taxaAggregation: {
    kind: 'selector',
    optsKey: kronaOptsKey,
    select: (state, sourceId, bucketKey, opts) => selectTaxaAggregation(state, sourceId, bucketKey, opts, kronaOptsKey(opts))
  },

  taxaAggregationSingle: {
    kind: 'selector',
    optsKey: kronaOptsKey,
    select: (state, sourceId, bucketKey, opts) => selectTaxaAggregationSingle(state, sourceId, bucketKey, opts, kronaOptsKey(opts))
  },

  taxaLeafAggregationSingle: {
    kind: 'selector',
    optsKey: kronaOptsKey,
    select: (state, sourceId, bucketKey, opts) =>
      selectTaxaLeafAggregationSingle(state, sourceId, bucketKey, opts, kronaOptsKey(opts))
  },

  taxaRankedBarSingle: {
    kind: 'selector',
    optsKey: rankedBarOptsKey,
    select: (state, sourceId, bucketKey, opts) =>
      selectTaxaRankedBarSingle(state, sourceId, bucketKey, opts, rankedBarOptsKey(opts))
  },

  taxaStackedBarSeries: {
    kind: 'selector',
    optsKey: kronaOptsKey,
    select: (state, sourceId, bucketKey, opts) => selectTaxaStackedBarSeries(state, sourceId, bucketKey, opts, kronaOptsKey(opts))
  },

  traitStackedBarSeries: {
    kind: 'selector',
    optsKey: kronaTraitOptsKey,
    select: (state, sourceId, bucketKey, opts) => selectTraitStackedBarSeries(state, sourceId, bucketKey, opts, kronaTraitOptsKey(opts))
  },

  traitAggregationSingle: {
    kind: 'selector',
    optsKey: kronaTraitOptsKey,
    select: (state, sourceId, bucketKey, opts) => selectTraitAggregationSingle(state, sourceId, bucketKey, opts, kronaTraitOptsKey(opts))
  },

  taxaNavigatorIndex: {
    kind: 'selector',
    optsKey: kronaOptsKey,
    select: (state, sourceId, bucketKey, opts) => selectTaxaNavigatorIndex(state, sourceId, bucketKey, opts, kronaOptsKey(opts))
  },

  taxaAutoDescendTarget: {
    kind: 'selector',
    optsKey: kronaOptsKey,
    select: (state, sourceId, bucketKey, opts) =>
      selectTaxaAutoDescendTarget(state, sourceId, bucketKey, opts, kronaOptsKey(opts))
  }
}
